/**
 * Meta açıklaması için HTML etiketlerini kaldırır.
 * @param {unknown} raw
 * @returns {string}
 */
export function stripHtmlForMeta(raw) {
    if (raw == null) return '';
    return String(raw)
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Arama motoru snippet uzunluğuna kısaltır.
 * @param {string} s
 * @param {number} [max]
 * @returns {string}
 */
export function truncateMetaDescription(s, max = 160) {
    const t = String(s || '').trim();
    if (t.length <= max) return t;
    return `${t.slice(0, max - 1).trim()}…`;
}
